import { Link } from 'react-router-dom';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import Contact from '../home/components/Contact';
import WhatsAppDiagnostic from '../home/components/WhatsAppDiagnostic';

export default function ReparationFenetreAluLyon() {
  const services = [
    {
      icon: 'ri-window-line',
      title: 'Remplacement Vitrage Alu',
      description: 'Remplacement de vitrage sur châssis aluminium. Vitrage haute performance et sécurisé.',
      price: 'À partir de 180€'
    },
    {
      icon: 'ri-slideshow-line',
      title: 'Systèmes Coulissants',
      description: 'Réparation et entretien de baies coulissantes, rails et galets de roulement.',
      price: 'À partir de 90€'
    },
    {
      icon: 'ri-tools-fill',
      title: 'Réparation Châssis',
      description: 'Redressement, soudure et réparation de châssis aluminium déformés.',
      price: 'À partir de 150€'
    },
    {
      icon: 'ri-contrast-drop-2-line',
      title: 'Traitement Oxydation',
      description: 'Traitement anti-corrosion et rénovation de l\'aluminium oxydé.',
      price: 'À partir de 100€'
    },
    {
      icon: 'ri-lock-2-line',
      title: 'Sécurisation Renforcée',
      description: 'Installation de systèmes anti-effraction pour fenêtres aluminium.',
      price: 'À partir de 140€'
    },
    {
      icon: 'ri-paint-line',
      title: 'Thermolaquage',
      description: 'Rénovation esthétique avec peinture thermolaquée haute résistance.',
      price: 'Sur devis'
    }
  ];

  const advantages = [
    {
      icon: 'ri-medal-line',
      title: 'Expertise Aluminium',
      description: 'Spécialistes des menuiseries alu depuis 15 ans'
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Intervention 24h',
      description: 'Service rapide partout à Lyon'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Garantie 10 ans',
      description: 'Tous nos travaux sont garantis'
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Prix Compétitifs',
      description: 'Devis gratuit et tarifs transparents'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-gray-800 via-gray-700 to-gray-600 pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
        <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
          <div className="max-w-3xl">
            <div className="inline-flex items-center space-x-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
              <i className="ri-map-pin-line text-white"></i>
              <span className="text-white text-sm font-medium">Lyon et Métropole - Rhône (69)</span>
            </div>
            
            <h1 className="text-5xl lg:text-6xl font-extrabold text-white mb-6 leading-tight">
              Réparation Fenêtre Aluminium Lyon
            </h1>
            
            <p className="text-xl text-white/90 mb-8 leading-relaxed">
              Spécialiste de la réparation de fenêtres aluminium à Lyon. Intervention rapide sur châssis alu, baies coulissantes et menuiseries contemporaines. Devis gratuit et garantie décennale.
            </p>
            
            <div className="flex flex-wrap gap-4">
              <a
                href="#contact"
                className="inline-flex items-center justify-center bg-white text-gray-800 px-8 py-4 rounded-full font-bold hover:bg-gray-50 transition-all shadow-lg whitespace-nowrap cursor-pointer"
              >
                Demander un Devis
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
              <a
                href="tel:0478XXXXXX"
                className="inline-flex items-center justify-center bg-white/10 backdrop-blur-sm text-white border-2 border-white px-8 py-4 rounded-full font-bold hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line mr-2"></i>
                Appel Gratuit
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <span className="text-gray-700 font-semibold text-xs uppercase tracking-wider">
              NOS SERVICES
            </span>
            <h2 className="text-4xl lg:text-5xl font-extrabold text-gray-900 mt-3 mb-4">
              Réparation Fenêtre Alu à Lyon
            </h2>
            <p className="text-gray-600 text-lg max-w-3xl mx-auto">
              Solutions professionnelles pour toutes vos menuiseries aluminium
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 cursor-pointer border border-gray-100"
              >
                <div className="w-14 h-14 bg-gradient-to-br from-gray-700 to-gray-600 rounded-full flex items-center justify-center mb-6">
                  <i className={`${service.icon} text-white text-2xl`}></i>
                </div>
                
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {service.title}
                </h3>
                
                <p className="text-gray-600 text-sm mb-4 leading-relaxed">
                  {service.description}
                </p>
                
                <div className="pt-4 border-t border-gray-100">
                  <span className="text-gray-800 font-bold text-lg">{service.price}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Advantages */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {advantages.map((advantage, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${advantage.icon} text-gray-700 text-3xl`}></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">
                  {advantage.title}
                </h3>
                <p className="text-gray-600 text-sm">
                  {advantage.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <article className="prose prose-lg max-w-none">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">
              Spécialiste Réparation Fenêtre Aluminium Lyon
            </h2>
            
            <p className="text-gray-700 leading-relaxed mb-6">
              Expert en <strong>réparation de fenêtres aluminium à Lyon</strong>, nous intervenons sur tous types de menuiseries alu : fenêtres, baies coulissantes, portes-fenêtres et vérandas. Notre expertise nous permet de diagnostiquer rapidement les problèmes et d'apporter des solutions durables.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Pourquoi Choisir l'Aluminium ?
            </h3>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              Les fenêtres aluminium offrent de nombreux avantages : design moderne et épuré, finesse des profilés permettant plus de luminosité, résistance exceptionnelle, durabilité de 40 à 50 ans, et large choix de coloris. À Lyon, l'aluminium est particulièrement apprécié pour les rénovations contemporaines et les grandes baies vitrées.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Nos Interventions sur Fenêtres Alu
            </h3>
            
            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-gray-700 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Baies coulissantes :</strong> Réparation de rails, remplacement de galets, ajustement de panneaux</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-gray-700 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Châssis déformés :</strong> Redressement professionnel et soudure aluminium</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-gray-700 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Oxydation :</strong> Traitement anti-corrosion et rénovation esthétique</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-gray-700 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Vitrage :</strong> Remplacement sur mesure avec vitrage haute performance</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-gray-700 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Sécurité :</strong> Installation de systèmes anti-effraction certifiés</span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Intervention Rapide à Lyon et sa Région
            </h3>
            
            <p className="text-gray-700 leading-relaxed mb-6">
              Nous intervenons rapidement dans tout Lyon (1er au 9ème arrondissement), la Métropole de Lyon et l'ensemble du département du Rhône. Notre équipe se déplace avec tout le matériel nécessaire pour diagnostiquer et réparer vos fenêtres aluminium sur place.
            </p>
          </article>
        </div>
      </section>

      {/* WhatsApp Diagnostic */}
      <WhatsAppDiagnostic />

      {/* Contact */}
      <Contact />
      
      <Footer />
    </div>
  );
}
